import styled from 'styled-components';

import { Avatar as ChakraAvatar } from '@chakra-ui/react';

export const AvatarComponent = styled(ChakraAvatar)`
  border-radius: 8px;
  font-weight: 600;
`;
